import type { UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import type { FetchResponse } from '@sydle/ui-api';
import type { Entry } from '../../types/site';
import { siteCustomAPI } from './index';
import { getConfig } from '@sydle/ui-utils';
import type { UIAppConfig } from '@sydle/ui-app';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GetMenuConfigsInput {
  lang?: string;
  hash?: string;
}

interface GetMenuConfigsOutput {
  menuEntries: Array<Entry>;
  footerEntries: Array<Entry>;
}

export async function getMenuConfigs(): Promise<FetchResponse<GetMenuConfigsOutput>> {
  const response = await siteCustomAPI.fetch<GetMenuConfigsInput, GetMenuConfigsOutput>('getMenuConfigs', {
    lang: getAPI<UserAPI>('userAPI')?.getCurrentLanguage() || 'en',
    hash: getConfig<UIAppConfig>('ui-app')?.applicationHash,
  });

  return response;
}
